let hostName = window.location.hostname;
let apiUri;
if (hostName  === 'al2-www.partner-s.net' || hostName  === 'lh.partner-s.net') {
	apiUri = 'https://al2-api.partner-s.net/';
}
else {
	apiUri = 'https://api.partner-s.net/';
}

const config = {
	root: '/pwa/',
	apiUri: apiUri,
	apiErrComment: 'インターネットに接続できませんでした',
};


export default config;
